import React from "react";
import { Users, Wrench } from "lucide-react";
import { GAP_LABEL } from "./DrillUserRow";

export const groupKey = (g) => `${g.from_sku}|${g.missing.join(",")}`;

/** Remediation groups: affected users grouped by base SKU x missing requirements. */
export default function GapGroupsTable({ gaps, onDrill, onFix, isAdmin }) {
  if (!gaps.remediation?.length) return null;
  return (
    <section className="ws-card glass" data-testid="gap-groups">
      <div className="ws-card-head">
        <h2>Who needs what</h2>
        <span className="muted small">Affected users grouped by their current base license and the entitlements they miss - click a row to see the users.</span>
      </div>
      <div className="ws-table-wrap">
        <table className="ws-table" data-testid="gap-groups-table">
          <thead>
            <tr>
              <th>Current license</th>
              <th>Missing</th>
              <th className="num">Users</th>
              <th className="num">Actions</th>
            </tr>
          </thead>
          <tbody>
            {gaps.remediation.map((g) => {
              const key = groupKey(g);
              return (
                <tr key={key} className="clickable" onClick={() => onDrill(g)} data-testid={`gap-group-${key}`}>
                  <td>
                    <div className="sku-name">{g.sku_name}</div>
                    <div className="sku-part mono">{g.from_sku === "__unlicensed__" ? "no base license" : g.from_sku}</div>
                  </td>
                  <td>
                    <div className="lic-chips">
                      {g.missing.map((m) => (
                        <span key={m} className="mini-chip warn">
                          {GAP_LABEL[m] || m}
                        </span>
                      ))}
                    </div>
                  </td>
                  <td className="num mono warn">{g.users.toLocaleString()}</td>
                  <td className="num">
                    <span className="row-actions">
                      <button type="button" className="tb-btn sm" onClick={(e) => (e.stopPropagation(), onDrill(g))} data-testid={`gap-group-drill-${key}`}>
                        <Users size={12} /> View users
                      </button>
                      {isAdmin && onFix && (
                        <button type="button" className="tb-btn sm" onClick={(e) => (e.stopPropagation(), onFix(g))} data-testid={`gap-group-fix-${key}`}>
                          <Wrench size={12} /> Plan fix
                        </button>
                      )}
                    </span>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </section>
  );
}
